export default {
  fields: {
    price: 'Preço',
    tax: 'Imposto',
    visible_to: 'Visível para',
  },
  buttons: {
    add_price: '+ Adicionar preço',
  },
};
